import { Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ChangelogPage } from '../features/changelog';
import useAppStore from '../store/rootStore.ts';
import { createPageBackgroundSx } from '../styles/pageBackground.ts';

export const Route = createFileRoute('/changelog')({
  component: ChangelogRouteComponent,
  beforeLoad: () => {
    if (!useAppStore.getState().config?.features.changelogEnabled) {
      throw redirect({ to: '/trade', replace: true });
    }
  },
});

const changelogPageSx = createPageBackgroundSx();

function ChangelogRouteComponent() {
  return (
    <Stack sx={changelogPageSx}>
      <ChangelogPage />
    </Stack>
  );
}
